import {BirthdayBoxMetadata, Product, Deal} from "@irati/types"

export default function birthdayBoxToProduct(deal: Deal): BirthdayBoxMetadata[] {
  const birthdayBoxList = deal?.birthdayBoxMetaData
  const products = deal?.productConfig?.products

  if (!birthdayBoxList || !products) {
    return []
  }

  const list: BirthdayBoxMetadata[] = []

  birthdayBoxList.forEach((box) => {
    const product = products.find((prod: Product) => prod.uuid === box.productId)
    if (product) {
      list.push({
        label: box.title,
        value: box.productId,
        ...product,
        ...box,
        name: box.title
      })
    }
  })

  return list
}
